import { Component, OnDestroy, OnInit ,AfterViewInit ,ViewChild, ElementRef,HostListener} from '@angular/core';
import { TableComponent } from '../../../shared/component/table/table.component';
import { AgGridTableService } from '../../../shared/services/ag-grid.service';
import { ApiCallsService } from '../../../shared/services/api-calls.service';
import { Subscription } from 'rxjs';
import { NgApexchartsModule } from 'ng-apexcharts';
import { CommonModule } from '@angular/common';
import { ChartOptions } from 'chart.js';
import { GridApi } from 'ag-grid-community';  // Import GridApi
import { FormsModule } from '@angular/forms';
import { TourService } from '../../../tour.service';

@Component({
  selector: 'app-site',
  imports: [TableComponent,CommonModule,NgApexchartsModule,FormsModule],
  templateUrl: './site.component.html',
  styleUrl: './site.component.scss'
})
 
export class SiteComponent implements OnInit ,OnDestroy,AfterViewInit {
  @ViewChild(TableComponent) table!: TableComponent;
  @ViewChild('tableWrapper') tableWrapper!: ElementRef<HTMLDivElement>;
  subscription:Subscription |null
  supervisorCountList: { name: string; count: number }[] = [];
  paymentGatewayData: { name: string; count: number }[] = [];
  chartOptions: any;
  gridApi: GridApi;  // Declare gridApi to access Ag-Grid API
  selectedSupervisor: string | null = null; 
  lastPayValue: string | null = null;
  lastSupervisor: string | null = null;
  processorDropdownOptions: { label: string; value: string; chartname:string }[] = [];
  processorDropdownOptions1: { label: string; value: string; chartname:string }[] = [];
  selectedCategory: string | null = null;
  payvalue: string = '';
  selectedvalue: string = '';
  selectedProcessorLabel: string = 'Processor Details';
   deductionKeys = [
  'mmc_deduction_day',
  'fixed_deduction_day',
  'CAM_deduction_day',
  'CS_deduction_day',
  'other_deduction_day'
];
pgHeaderMap: { key: string; normalizedName: string }[] = [];
  constructor(private aggrid:AgGridTableService,private apiService: ApiCallsService,private tour: TourService) { }

  public revenugrowth: ChartOptions | any = {};
//   // Add this to match exactly the @Input type of <app-table>
filterList: { key: string; label: string }[] = [];
statusMapInput: Record<string, 'active' | 'inactive'> = {};

/* add shorting */

  searchTerm = '';
  showSearch = false;
  sortState = {
    super: { field: 'name' as 'name' | 'count', direction: 'asc' as 'asc' | 'desc' },
    pay: { field: 'name' as 'name' | 'count', direction: 'asc' as 'asc' | 'desc' }
  };
/* add shorting */
  
  ngAfterViewInit(): void {
  }


  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
sitetabledata:any
     fetchPaymentGatewayData(): void {
      this.subscription = this.apiService.getDashboardData().subscribe((response) => {
        if (response && response.Data && response.Data.paymentgateway) {
          const paymentGateway = response.Data.paymentgateway;
          this.pgHeaderMap = this.headersItems.map((h: any) => ({
            key: h.key,
            normalizedName: this.normalizeName(h.name)
          }));          
          this.paymentGatewayData = Object.entries(paymentGateway)
          
            .filter(([key]) => key !== 'Total') // Exclude "Total"
            .map(([name, count]) => ({
              name: name.toUpperCase(),
              count: count as number,
            }));

          // ✅ FIX: Trigger filtering after data arrives
          this.filterAndSort('pay');

        } else {
          console.error('Invalid response structure:', response);
        }
      });
    }
headersItems:any
      ngOnInit(): void {
        this.subscription = this.apiService.getSiteList().subscribe((response) => {
        
          if (response && response.Data) {
            // Store the site table data
                response.Data.list = response.Data.list.map((item: any) => {
                  this.deductionKeys.forEach((key) => {
                    const value = Number(item[key]);

                    if (!isNaN(value)) {
                      if (value > 0 && value <= 30) {
                        item[key] = 'Enable';
                      } else if (value >= 31 && value <= 99) {
                        item[key] = 'Daily';
                      } else {
                        item[key] = 'Disable';
                      }
                    } else {
                      item[key] = 'Disable'; // fallback in case it's not a number
                    }
                  });

                  return item;
                });
          this.sitetabledata = response; // Store the data for later use
          //console.log('Site Table Data:', this.sitetabledata); // Log the data for debugging
            this.aggrid.processTableData(response);
            this.supervisor(response.Data.list); // Process supervisor data
            this.filterAndSort('super');
            // Populate processorDropdownOptions here
              const headerData = response.Data.header;
              this.headersItems = headerData
              this.processorDropdownOptions = headerData

                .filter((item: { dropdown: boolean; }) => item.dropdown === true)
                .map((item: {chart_type: any; name: any; key: any; }) => ({
                  label: item.name,
                  value: item.key,
                  chartname: item.chart_type
                }));

                this.filterList = this.processorDropdownOptions.map((item) => {
                  const isChargeDeduction = item.label === 'Charges Deduction' && !item.value;
                  return {
                    key: isChargeDeduction ? 'charge_deduction' : item.value,
                    label: item.label
                  };
                }); 

              // 2. Manually add supervisor_name and payment to the filterList
              this.filterList.unshift(
                { key: 'payment', label: 'Payment Gateways' },
                { key: 'supervisor_name', label: 'Supervisor' } 
              );
              console.log(JSON.stringify(this.filterList));
              
              //console.log("processorDropdownOptions",this.processorDropdownOptions)
              // Trigger the first option if available
              this.processorDropdownOptions1=this.processorDropdownOptions
              if (this.processorDropdownOptions.length > 0) {
                const firstOption = this.processorDropdownOptions[0];
                this.onProcessorDropdownSelect(firstOption.value, firstOption.label,firstOption.chartname);
              }
          } else {
            console.error('Invalid response structure:', response);
          }
        });
        this.fetchPaymentGatewayData();
        this.filterAndSort('pay')
        
      }  
      supervisor(data: any[]): void {
        if (!Array.isArray(data)) {
          console.error('Supervisor data is not an array:', data);
          return;
        }
        // Ensure each item in the array has a `supervisor_name` property
        const counts = data.reduce((acc: Record<string, number>, site: any) => {
          if (site && typeof site === 'object' && 'supervisor_name' in site) {
          const name = site.supervisor_name && site.supervisor_name.trim() !== '' ? site.supervisor_name : 'N/A';
            acc[name] = (acc[name] || 0) + 1;
          } else {
            console.warn('Invalid site data:', site);
          }
          return acc;
        }, {});
    
        // Convert the counts object into an array for rendering

        this.supervisorCountList = Object.entries(counts).map(([name, count]) => ({
          name,
          count,
        }));
        this.supervisorCountList.sort((a, b) => a.name.localeCompare(b.name));
        //console.log('Supervisor Count:', this.supervisorCountList);
      }
      /* add shorting */
      toggleSearch() {
        this.showSearch = !this.showSearch;
        if (!this.showSearch) {
          this.searchTerm = '';
          this.filterAndSort('super');
        }
      }
      filteredSupervisorList: any[] = [];
      filteredPayList: any[] = [];
normalizeName(name: string): string {
  return name
    ?.toLowerCase()
    .replace(/payment gateway/g, '') // remove unwanted text
    .replace(/\s+/g, '')             // remove spaces
    .trim();
}
filterAndSort(type: 'super' | 'pay') {
  const term = this.searchTerm.toLowerCase();
  let data: any[] = [];

  if (type === 'super') {
    data = this.supervisorCountList;
  } else {
    data = this.paymentGatewayData;
  }

  const { field, direction } = this.sortState[type];

  const filteredData = data
    .filter(s => s.name.toLowerCase().includes(term))
    .map(item => {
      const cleanName = item.name
        .replace(/payment gateway/gi, '')
        .trim()
        .toUpperCase();

      // Normalize cleanName to match pgHeaderMap normalizedName
      const normalizedClean = this.normalizeName(cleanName);

      // Find matching entry in pgHeaderMap
      const match = this.pgHeaderMap.find(
        (h: any) => h.normalizedName === normalizedClean
      );

      return {
        name: cleanName,
        tableKey: match?.key || '',
        count: item.count
      };
    })
    .sort((a, b) => {
      if (field === 'name') {
        return direction === 'asc'
          ? a.name.localeCompare(b.name)
          : b.name.localeCompare(a.name);
      } else {
        return direction === 'asc'
          ? a.count - b.count
          : b.count - a.count;
      }
    });

  if (type === 'super') {
    this.filteredSupervisorList = filteredData;
  } else {
    this.filteredPayList = filteredData;
    console.log(this.filteredPayList);
  }
}

      
      toggleSort(field: 'name' | 'count', type: 'super' | 'pay') {
        const current = this.sortState[type];

        if (current.field === field) {
          current.direction = current.direction === 'asc' ? 'desc' : 'asc';
        } else {
          current.field = field;
          current.direction = 'asc';
        }

        this.filterAndSort(type);
      }
      


      onStatusUpdated(event: { key: string; value: 'inactive' }) {

        if (event.key === 'payment') {
              this.sendDataPay(this.lastPayValue ?? '', '', []);
        }
        else{
          this.sendDataS('',event.key)
          this.resetChart(event.key)
        }
      }
    activeDeductionKey:string = ''
    sendDataS(value: string, fieldKey: string): void {
      const isSameField = this.selectedvalue === fieldKey;
      this.selectedvalue = fieldKey;

      // ✅ Scroll only if user clicks different fieldKey
      if (!isSameField) {
        this.scroll();
      }
      
      const isRepeatClick = this.lastSupervisor === value;
      // Use original fieldKey for everything except statusMapInput
      const statusMapKey = this.deductionKeys.includes(fieldKey) ? 'charge_deduction' : fieldKey;

      if (isRepeatClick || value === '') {
        if (fieldKey === 'charge_deduction') {
          fieldKey = this.activeDeductionKey
        }
        this.aggrid.get_particular_row('', fieldKey);
        this.selectedSupervisor = '';
        this.lastSupervisor = null;
        this.table.toggleColumnVisibilityByField(fieldKey, false);

        this.statusMapInput = {
          ...this.statusMapInput,
          [statusMapKey]: 'inactive'
        };
        return;
      }

      this.selectedSupervisor = value;
      this.aggrid.get_particular_row(value, fieldKey);
      this.lastSupervisor = value;
      this.table.toggleColumnVisibilityByField(fieldKey, true);

      this.statusMapInput = {
        ...this.statusMapInput,
        [statusMapKey]: 'active'
      };
    }

sendDataPay(value: string, key:string='', paymentArray: any[] = []): void {

  // 🚫 GUARD: empty / reset call
  if (!value) {
    this.lastPayValue = null;
    this.payvalue = '';

    this.statusMapInput = {
      ...this.statusMapInput,
      payment: 'inactive'
    };
    return;
  }

  const selectedKey = value.toLowerCase();
  const isSameField = this.selectedvalue === selectedKey;
  this.selectedvalue = selectedKey;

  if (!isSameField) {
    this.scroll();
  }

  if (this.lastPayValue === key.toLowerCase()) {
    this.table.toggleColumnVisibilityByField(selectedKey, false);
    this.aggrid.get_particular_row('', selectedKey);
    this.lastPayValue = null;
    this.payvalue = '';

    this.statusMapInput = {
      ...this.statusMapInput,
      payment: 'inactive'
    };
    return;
  }

  paymentArray.forEach((element: any) => {
    const key2 = "pg_enable_" + element.name.toLowerCase();
    this.aggrid.get_particular_row('', key2);
    this.table.toggleColumnVisibilityByField(key2, false);
  });

  this.payvalue = key;
  this.aggrid.get_particular_row('Y', selectedKey);
  this.table.toggleColumnVisibilityByField(selectedKey, true);
  this.lastPayValue = key;

  this.statusMapInput = {
    ...this.statusMapInput,
    payment: 'active'
  };
}

    processSiteTypeData(data: any[], f_type: string, option3: string): void {
      // alert(f_type);
      const typeCounts: Record<string, number> = {};
      const displayToOriginal: Record<string, string> = {};
      const labelToKeyMap: Record<string, string> = {};
        if (f_type === 'Charges Deduction') {
          const found = this.sitetabledata.Data.header.find((item: any) => item.name === f_type && item.dropdow_value);
          const keyArr: string[] = found?.dropdow_value?.split(',') || [];
              console.log("key",keyArr);
          const labelMap: Record<string, string> = {};
          for (const k of keyArr) {
            const field = this.sitetabledata.Data.header.find((item: any) => item.key === k);
            let label = field?.name || k;
            label = label.replace(/ Deduction$/i, '');
            labelMap[k] = label;
            labelToKeyMap[label] = k; // 👈 reverse mapping
          }

          const yesCounts: number[] = [];
          const noCounts: number[] = [];

          for (const field of keyArr) {
            let y = 0, n = 0;
            for (const item of data) {
              const valRaw = item?.[field];
              console.log("valraw",valRaw);
              if (valRaw =="Disable") {
                n++;
              } else if ((valRaw) =="Enable"||(valRaw) == "Daily") {
                y++;
              } else {
                n++;
              }
            }

            yesCounts.push(y);
            noCounts.push(n);
          }
          console.log("nocount",noCounts)
          console.log("yescount",yesCounts)
          const enableData = keyArr.map((field, i) => ({
            x: labelMap[field].replace(/ Deduction$/i, ''),
            y: yesCounts[i] || 0
          }));

          const disableData = keyArr.map((field, i) => ({
            x: labelMap[field].replace(/ Deduction$/i, ''),
            y: noCounts[i] || 0
          }));

          this.revenugrowth = {
            series: [
              {
                name: 'Enable',
                data: enableData
              },
              {
                name: 'Disable',
                data: disableData
              }
            ],
            chart: {
              type: 'bar',
              height: 242,
              toolbar: {
                show: false
              },
              events: {
                dataPointSelection: (event:any, chartContext:any, config:any) => {
                  const seriesIndex = config.seriesIndex;
                  const dataPointIndex = config.dataPointIndex;
                  const selectedData = this.revenugrowth.series[seriesIndex].data[dataPointIndex];
                  const isEnable = this.revenugrowth.series[seriesIndex].name === 'Enable';
                  const clickedValue = isEnable ? 'Enable' : 'Disable';
                  const originalKey = labelToKeyMap[selectedData.x];                  
                  this.activeDeductionKey = originalKey
                  this.sendDataS(clickedValue, originalKey);
                }
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '40%',
                  distributed: true  // <-- Important for individual bar interaction
                }
              }
            },
            plotOptions: {
              bar: { horizontal: false, columnWidth: '40%' }
            },
            dataLabels: { 
              enabled: true,
              offsetY: -20, // <--- Empuja hacia arriba los números
              style: {
                fontSize: '12px',
                colors: ["white"]
              },
              formatter: function (val: number) {
                return val.toString();
              }
            },
            xaxis:  { type: 'category' },
            colors: ['#00C853', '#FF3D00'],
            legend: { position: 'top' }
          };
          return; // important: stop here to avoid executing generic logic
        }

      for (const item of data) {
      
        let raw = item?.[f_type]?.toString().trim() || 'Other';
        let display = '';

        if (raw.toLowerCase() === 'null' || raw === '') {
          display = 'Other';
        } else if (raw === 'Y') {
          display = 'Yes';
        } else if (raw === 'N') {
          display = 'No';
        } else {
          display = raw.charAt(0).toUpperCase() + raw.slice(1);
        }

        if (!display) display = 'Other';
        if (!raw) raw = 'Other';

        displayToOriginal[display] = raw;
        typeCounts[display] = (typeCounts[display] || 0) + 1;
      }

      const labels = Object.keys(typeCounts);
      const rawSeries = Object.values(typeCounts);

        const series =
        option3 === 'bar' || option3 === 'line'
          ? [{ name: this.formatLabel(f_type), data: rawSeries }]
          : rawSeries;

          this.revenugrowth = {
            series,
            labels,
            colors: ['#19CAD7', '#DEF8C3', '#FF0000', '#F9C74F', '#F3722C', '#AEEED2'],
            chart: {
              type: option3,
              height: 255,
              toolbar: {
                show: false   // Hides the toolbar (menu icon)
              },
              events: {
                mouseMove: () => {
                  document.body.style.cursor = 'pointer';
                },
                mouseLeave: () => {
                  document.body.style.cursor = 'default';
                },
                dataPointSelection: (event: any, chartContext: any, config: any) => {
                  const index = config.dataPointIndex;
                  const label = labels[index].replace(/_$/i, '');
                  const originalValue = displayToOriginal[label] || label;
                  this.sendDataS(originalValue, f_type);
                }
              }
            },
            plotOptions: {
              [option3]: {
                expandOnClick: true,
                horizontal: option3 === 'bar' // Optional: Horizontal bar
              }
            },
            xaxis: option3 === 'bar' || option3 === 'line'
              ? {
                  categories: labels
                }
              : undefined,
            legend: {
              formatter: function (seriesName: string, opts: any) {
                const value =
                  option3 === 'bar' || option3 === 'line'
                    ? opts.w.globals.series[opts.seriesIndex].data.reduce((a: number, b: number) => a + b, 0)
                    : opts.w.globals.series[opts.seriesIndex];
                return `${seriesName.replace(/_$/i, '')} - ${value}`;
              }
            },
            dataLabels: {
              enabled: true
            },
            tooltip: {
              enabled: true,
              labels: {
                formatter: (val: number, opts: any) => {
                  const index = opts.seriesIndex;
                  return `<div class='chart_lable' style='cursor: pointer'>${labels[index].replace(/_$/i, '')}: ${val}</div>`;
                }
              }
            },
            responsive: [
              
              {
                breakpoint: 1024,
                options: {
                  chart: {
                    width: 300,
                  },
                  legend: {
                    position: 'bottom',
                    floating: false,
                    horizontalAlign: 'center',
                    offsetY: 0,
                    markers: { width: 8, height: 8 },
                    fontSize: '11px'
                  },
                  dataLabels: {
                    style: { fontSize: '10px' }
                  }
                }
              },
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 280,
                    height: 350
                  },
                  legend: {
                    position: 'bottom',
                    floating: false,
                    horizontalAlign: 'center',
                    offsetY: 0,
                    markers: { width: 8, height: 8 },
                    fontSize: '11px'
                  },
                  dataLabels: {
                    style: { fontSize: '10px' }
                  }
                }
              },

            ]


          };
    }

    onClearSupervisorHighlight() {
      // Call sendDataS with empty values to remove highlight
      this.sendDataS('', 'type');
      this.sendDataS('','supervisor_name')
      this.sendDataPay('', '', []);
    }
    scrollToTable(): void {
      const siteTabular = document.getElementById('site_tabular');
      if (siteTabular) {
        window.scrollTo({ top: siteTabular.scrollHeight, behavior: 'smooth' });
      }
     
    }
    @ViewChild('processorDropdown') processorDropdown!: ElementRef;

    public showProcessorDropdown = false;
    toggleProcessorDropdown() {
      this.showProcessorDropdown = !this.showProcessorDropdown;
      if(this.showProcessorDropdown){
          const headerData = this.sitetabledata.Data.header; // or wherever your array is
          console.log("header-header",headerData);

        this.processorDropdownOptions = headerData
          .filter((item: { dropdown: boolean }) => item.dropdown === true)
          .map((item: { name: string; key: string }) => {
            let value = item.key;
            if (!value || value.trim() === '') {
              value = item.name.replaceAll(' ', '_');
            }
            return {
              label: item.name,
              value: value
            };
          });

      }
    }
    
    onProcessorDropdownSelect(option: any, option2: any,option3: any) {
      if (option === null || option === undefined || option === '') {
        option = option2;
      }
      this.selectedProcessorLabel = option2
      this.processSiteTypeData(this.sitetabledata.Data.list,option,option3);
      this.showProcessorDropdown = false; 
    }
    @HostListener('document:click', ['$event'])
      onDocumentClick(event: MouseEvent) {
        // Only close if dropdown is open and click is outside the dropdown and toggle button
        if (
          this.showProcessorDropdown &&
          this.processorDropdown &&
          !this.processorDropdown.nativeElement.contains(event.target) &&
          !(event.target as HTMLElement).classList.contains('dropnav-img')
        ) {
          this.showProcessorDropdown = false;
        }
      }
      formatLabel(label: string): string {
          return label
            .replace(/_/g, ' ')                // Replace underscores with space
            .replace(/\w\S*/g, (txt) =>        // Capitalize each word
              txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()
            );
        }
        resetChart(field:any) {
          //alert(field);
          this.selectedCategory = null;
        }
        scroll(){
          const siteTabular = document.getElementById('site_tabular');
           if (siteTabular) {
            window.scrollTo({ top: siteTabular.scrollHeight, behavior: 'smooth' });
          }
        }
}
